export default "__VITE_ASSET__Dc$RsZg7__"